<script lang="ts" setup>
import BaseButton from '@/components/BaseButton.vue';

type GreetFunction = () => Promise<boolean>;

const props = withDefaults(
  defineProps<{
    callback?: GreetFunction;
  }>(),
  {
    callback: () => Promise.resolve(true),
  },
);

const emit = defineEmits<{
  (event: 'action'): void;
}>();

const { t } = useLocales();
const isLoading = ref<boolean>(false);

const clickHandler = async (): Promise<void> => {
  isLoading.value = true;

  const success: boolean = await props.callback();

  if (success) {
    emit('action');
  }

  isLoading.value = false;
};
</script>

<template>
  <div class="inner-reload">
    <p class="inner-reload__text text-h5">
      {{ t('text.oops') }}
    </p>

    <base-button
      class="inner-reload__btn"
      size="lg"
      type="button"
      color="secondary"
      :loading="isLoading"
      @click="clickHandler"
    >
      <svg
        class="inner-reload__icon"
        width="16"
        height="16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.01 6.232h3v-3"
          stroke="#fff"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.89 11.89a5.5 5.5 0 1 1 0-7.78l2.12 2.122"
          stroke="#fff"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      {{ t('button.reload') }}
    </base-button>
  </div>
</template>

<style lang="scss" scoped>
.inner-reload {
  $this: 'inner-reload';

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  position: absolute;
  inset: 0;
  z-index: 10;
  background-color: rgb(255 255 255 / 70%);
  backdrop-filter: blur(4px);

  &__text {
    text-align: center;
    margin-bottom: 24px;
  }

  &__icon {
    margin-right: 4px;
  }
}
</style>
